import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Actions, Services, Selectors
import * as actions from 'actions';
import { isActionInProgress } from 'selectors';
import { LOGIN, SEND_EXTERNAL_AUTH_TOKEN } from 'actionTypes';

// Components
import Form from 'Components/Form';
import OAuthButtons from 'Components/Auth/OAuthButtons';
import AuthModalNavButton from './AuthModalNavButton';

import { Text, Modal, Alert } from 'frontend-component-library';

import { FORM_KEYS } from 'Components/Auth/AuthModal';

export const LOGIN_KEY = 'login';

class LoginForm extends Component {
  handleSubmit = ({ email, password }) => {
    this.props.login(email, password);
  };

  render() {
    const { successAlert, errors, closeModal, updateModal } = this.props;
    return (
      <React.Fragment>
        <Modal.Header closeModal={closeModal}>
          <h2 className="AuthModalHeader">Log In</h2>
          <div className="AuthModal-header-links">
            <AuthModalNavButton
              updateModal={updateModal}
              formToDisplay={FORM_KEYS.registration}
              text="Sign up"
            />
            <AuthModalNavButton
              updateModal={updateModal}
              formToDisplay={FORM_KEYS.reset}
              text="Reset Password"
            />
          </div>
        </Modal.Header>
        <Modal.Section>
          <Alert type="success">{successAlert}</Alert>
          <Form
            onSubmit={this.handleSubmit}
            disabled={this.props.isFetching}
            errors={errors}
            submitText="Log In"
            className="AuthForm"
          >
            <Text
              name="email"
              text="Email"
              placeholder="Enter your email..."
              type="email"
              required
            />
            <Text
              name="password"
              text="Password"
              placeholder="Enter your password..."
              type="password"
              required
            />
          </Form>
        </Modal.Section>
        <Modal.Section>
          <OAuthButtons authType="login" />
        </Modal.Section>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    isFetching: isActionInProgress(state, LOGIN),
    errors: {
      ...state.endpointErrors[LOGIN],
      ...state.endpointErrors[SEND_EXTERNAL_AUTH_TOKEN],
    },
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      login: actions.login,
    },
    dispatch
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);



// WEBPACK FOOTER //
// ./src/Components/Auth/AuthModal/LoginForm.js